@if (email?.fromAddress) {
	<div>
		<div class="row">
			<div class="col bold-text aut-email-title">Email Notification</div>
			@if (email?.dateSent) {
				<div class="col justify-content-end d-flex aut-email-date">
					{{ email.dateSent | date }}
				</div>
			}
		</div>
		<div class="row">
			@if (email?.dateSent) {
				<div class="col justify-content-end d-flex aut-email-date">
					{{ email.dateSent | date: 'hh:mm a' }} {{ emailTimeZone }}
				</div>
			}
		</div>
		<div class="row">
			<div class="col">
				From:
				<span class="bold-text aut-email-from">{{ email?.fromAddress }}</span>
			</div>
		</div>
		<div class="row">
			<div class="col">
				To:
				<span class="bold-text aut-date-email-to">{{
					email?.toAddresses | arrayJoin: '; '
				}}</span>
			</div>
		</div>
		@if (email?.ccAddresses?.length) {
			<div class="row">
				<div class="col">
					Cc:
					<span class="bold-text aut-date-email-cc">{{
						email?.ccAddresses | arrayJoin: '; '
					}}</span>
				</div>
			</div>
		}
		@if (isAdminNotification && email?.bccAddresses?.length) {
			<div class="row">
				<div class="col">
					Bcc:
					<span class="bold-text aut-date-email-bcc">{{
						email?.bccAddresses | arrayJoin: '; '
					}}</span>
				</div>
			</div>
		}
		<div class="row">
			<div class="col">
				Subject:
				<span class="bold-text aut-email-subject">{{ email?.subject }}</span>
			</div>
		</div>
		<div class="row">
			<div class="col aut-email-body" [innerHTML]="email?.body"></div>
		</div>
	</div>
}
